// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // baseUrl: 'http://localhost:5000/api/'
  // baseUrl: 'https://prod.lemurmaritime.com/api/'
  // baseUrl: 'http://localhost:3000/api/'
  // baseUrl: 'https://app.lemurmaritime.com/api/'
  // baseUrl: 'http://ec2-34-251-46-133.eu-west-1.compute.amazonaws.com/api/'
  baseUrl: 'https://stage.lemurtechnologies.com/api/',
  // baseUrl: 'http://192.168.29.21:3000/api/'

};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
